import { Storage } from 'aws-amplify'
import { MaintenanceEvent } from '../API'

export const getPresignedURL = async (event: MaintenanceEvent) => {
  return Storage.get(event?.reportLink as string)
    .then((res) => ({ ...event, reportLink: res as string }))
}
